import React, { useEffect, useState } from 'react';
import { objectOf, string, any, bool } from 'prop-types';
import get from 'lodash/get';
import { connect } from 'react-redux';
import SubscriptionComboBox from '../subscription-combo-box';
import {
  getPrimarySection,
  getSourceDisplayName,
} from '../../../helpers/story-helpers';
import { trackUserInteraction } from '../../../helpers/datalayer-utils';
import { syndicatedSource } from '../../../helpers/utils';
import AdWithPlaceholder from '../../molecules/ad-with-placeholder';
import AboutAuthor from '../authors/aboutAuthor';
import { WithLazy } from '@quintype/components';

import './footer.module.css';

const SyndicatedSource = ({ story }) => {
  const author = get(story, 'author-name');
  if (author === 'PTI') return null;

  const syndicatedFrom = get(story, ['metadata', 'story-attributes', 'syndicatedfrom', '0']);
  return <div styleName="syndicated-source">{getSourceDisplayName(syndicatedFrom)}</div>;
};

SyndicatedSource.propTypes = {
  story: objectOf(any).isRequired,
};

const Footer = (props) => {
  useEffect(() => {
    var cX = window.cX || {};
    cX.callQueue = cX.callQueue || [];
    cX.CCE = cX.CCE || {};
    cX.CCE.callQueue = cX.CCE.callQueue || [];
    cX.CCE.callQueue.push([
      'run',
      {
        targetElementId: 'recomended-for-you-piano',
      },
    ]);
  }, []);

  const authorDetails = props.story.authors ?? [];

  const datalayerFields = {
    category: 'article page',
    action: 'NA',
    label: props.story.headline,
    event: 'event articlepage',
    cd22: 'link',
    cd23: 'NA',
    cd24: 'NA',
    cd26: syndicatedSource(props.story),
    cd31: props.story['story-template'] || 'text',
    cd35: 'NA',
    cd34: 'NA',
  };

  function checkBio(author) {
    return author.bio;
  }
  const isLiveBlog = get(props, ['story', 'story-template']) === 'live-blog';

  return (
    <React.Fragment>
      {props.story['story-template'] === 'news-elsewhere' && (
        <a href={props.story.metadata['reference-url']} styleName="read-more">
          Read More
        </a>
      )}
      <SectionLink
        section={getPrimarySection(props.story.sections)}
        storyHeadline={props.story.headline}
        isGeoBlock={props.isGeoBlock}
        isLiveBlog={isLiveBlog}
        isPremiumTemplate={props?.isPremiumTemplate}
        isSubscriber={props.isSubscriber}
      />

      <WithLazy>
        {() => (
          <>
            {authorDetails && authorDetails.some(checkBio) && (
              <h4 styleName="about-the-author">WRITTEN BY</h4>
            )}
            {authorDetails &&
              authorDetails.map((author, i) => {
                return <AboutAuthor authorDetails={author} key={i} />;
              })}
          </>
        )}
      </WithLazy>

      <WithLazy>
        {() => (
          <SubscriptionComboBox
            source="footer-Story Page"
            variant="horizontal"
            datalayerFields={datalayerFields}
          />
        )}
      </WithLazy>
      <div
        className="content-center ad-bottom-margin mobile-only"
        styleName="belowrecommendedadunit"
      >
      </div>
    </React.Fragment>
  );
};

const SectionLink = ({
  section,
  storyHeadline,
  isGeoBlock,
  isLiveBlog,
  isSubscriber,
  isPremiumTemplate = false,
}) => {
  const [isMobile, setIsMobile] = useState(false);
  const [isDesktop, setIsDesktop] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      setIsMobile(width <= 768);
      setIsDesktop(width > 768);
    };
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const datalayerFields = {
    category: 'article page',
    action: storyHeadline,
    event: 'event articlepage',
    cd22: 'link',
    cd23: 'story footer',
    cd24: 'NA',
    cd26: 'NA',
    cd31: 'Story',
    cd35: 'NA',
    cd34: 'NA',
  };
  return (
    <div styleName="authoritative-section" className="paywall">
      <>
      </>
      {!isGeoBlock && (
        <>
          <div styleName="static-text">
            Watch&nbsp;
            <a
              href={`/live-tv?src=read_more`}
              target="_blank"
              rel="noopener noreferrer"
              styleName="authoritative-section-link"
              onClick={() => trackUserInteraction(datalayerFields)}
            >
              LIVE TV
            </a>, Get&nbsp;
            <a
              href={`/markets?src=read_more`}
              target="_blank"
              rel="noopener noreferrer"
              styleName="authoritative-section-link"
              onClick={() => trackUserInteraction(datalayerFields)}
            >
              Stock Market
            </a> Updates, Top&nbsp;
            <a
              href={`/business?src=read_more`}
              target="_blank"
              rel="noopener noreferrer"
              styleName="authoritative-section-link"
              onClick={() => trackUserInteraction(datalayerFields)}
            >
              Business
            </a>,&nbsp;
            <a
              href={`/ipos?src=read_more`}
              target="_blank"
              rel="noopener noreferrer"
              styleName="authoritative-section-link"
              onClick={() => trackUserInteraction(datalayerFields)}
            >
              IPO
            </a> and&nbsp;
            <a
              href={`/the-latest?src=read_more`}
              target="_blank"
              rel="noopener noreferrer"
              styleName="authoritative-section-link"
              onClick={() => trackUserInteraction(datalayerFields)}
            >
              Latest News
            </a>&nbsp;on NDTV Profit.
          </div>
        </>
      )}
    </div>
  );
};

SectionLink.propTypes = {
  section: objectOf(any).isRequired,
  storyHeadline: string.isRequired,
  isGeoBlock: bool,
  isLiveBlog: bool,
  isSubscriber: bool,
  isPremiumTemplate: bool,
};

Footer.propTypes = {
  story: objectOf(any).isRequired,
  isGeoBlock: bool,
  isPremiumTemplate: bool,
  isSubscriber: bool,
};

const mapStateToProps = (state) => {
  return {
    isSubscriber: get(state, ['userData', 'isSubscriber'], false),
  };
};
export default connect(mapStateToProps, () => ({}))(Footer);
